import type { Event } from '@patsnap/tahiti-core';
import type { FtoTaskStep } from '../../enums';
import type { FtoReportState } from './novelty-check-report-state';

export const FtoReportContext = Symbol.for('FtoReportContext');

/**
 * 新颖性检查报告(状态模式)上下文
 */
export interface FtoReportContext {
    /**
     * 获取当前状态
     */
    getCurrentState(): FtoReportState;

    /**
     * 获取当前步骤
     */
    getCurrentStep(): FtoTaskStep;

    /**
     * 获取前一个状态
     */
    getPreviousState(): FtoReportState | null;

    /**
     * 切换到指定状态
     * @param state 目标状态
     */
    transitionTo(state: FtoReportState): Promise<void>;

    /**
     * 获取状态
     * @param step 状态步骤
     */
    getState(step: FtoTaskStep): FtoReportState;

    /**
     * 进入下一步
     */
    next(): Promise<void>;

    /**
     * 返回上一步
     */
    previous(): Promise<void>;

    /**
     * 初始化报告
     */
    initialize(): Promise<void>;

    /**
     * 状态变化事件
     */
    readonly onStateChange: Event<FtoTaskStep>;
}
